import './navigation.css'
import { useStore } from "../state/state.ts";
import { clsx, inputOnKeyUp } from "../functions.ts";
import { type StepDescription } from "../state/types.ts";
import { MAIN_PROPERTIES } from "../state/properties.ts";

export default function Navigation(props: {steps: Array<StepDescription>, validation: ()=>boolean}) {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties);
  const _properties = MAIN_PROPERTIES.reduce((acc, p)=>{
      acc[p.key] = useStore((state)=>state[p.key]);
      return acc;
  },{});  //MUST EXIST FOR REACTIVITY TO WORK
  const current_step_number = useStore((state) => state.current_step_number);
  const current_step = useStore((state) => state.current_step);
  const increment_step = useStore((state) => state.increment_step);
  const decrement_step = useStore((state) => state.decrement_step);
  const is_last_step = useStore((state) => state.is_last_step);
  const reset = useStore((state) => state.reset);

  return (
    <div className="navigation">
      <div className="navigation__buttons_left">
        <NavigationButtonOutline tabIndex={0} hidden={current_step_number == 0} label="neu" onClick={()=>{reset()}}/>
        <NavigationButtonOutline tabIndex={0} hidden={current_step_number == 0} disabled={current_step_number == 0} label="zurück" onClick={()=>{decrement_step()}}/>
      </div>

      <div aria-hidden className="navigation__steps">
        {props.steps.map( (step: StepDescription, index: number) => 
        <NavigationStep key={step.id} active={current_step_number == index} number={index + 1} label={current_step.label}/>
        )}
      </div>
      <div className="navigation__buttons_right">
        <NavigationButton id="next-button" tabIndex={0} hidden={is_last_step()} disabled={!props.validation()} label="weiter" onClick={()=>{increment_step()}}/>
      </div>
    </div>);
}


export function NavigationButton(props: {id?:string, tabIndex: number, label: string, hidden:boolean, disabled: boolean, onClick: () => void}) {
  const onClick = ()=>{if (props.disabled){return;}; props.onClick();}
  return <div 
    id = {props.id}
    tabIndex={props.tabIndex}
    inert={props.hidden}
    role="button"
    aria-label={props.label}
    className={clsx("navigation__button", props.disabled && "navigation__button--disabled", props.hidden && "navigation__button--hidden")} 
    onClick={onClick}
    onKeyUp={(event)=>inputOnKeyUp(event, onClick)}
  >{props.label}</div>;
}

export function NavigationButtonOutline(props: {tabIndex: number, label: string, hidden:boolean, disabled: boolean, onClick: () => void}) {
  const onClick = ()=>{if (props.disabled){return;}; props.onClick();}
  return <div 
    tabIndex={props.tabIndex}
    aria-hidden={props.hidden}
    aria-disabled={props.disabled}
    inert={props.hidden}
    role="button"
    aria-label={props.label}
    className={clsx("navigation__button navigation__button--outline", props.disabled && "navigation__button--disabled", props.hidden && "navigation__button--hidden")} 
    onClick={onClick}
    onKeyUp={(event)=>inputOnKeyUp(event, onClick)}>
      {props.label}
  </div>;
}


export function NavigationStep(props: {active: boolean, label: string, number: number}) {
  const set_step = useStore((state) => state.set_step);
  const current_step_number = useStore((state) => state.current_step_number);

  const interactive = current_step_number > (props.number - 1);
  const onClick = interactive ? () => {set_step((props.number - 1))} : ()=>{};
  return (
    <div className={clsx("navigation__step", props.active && "navigation__step--active", interactive ? "navigation__step--interactive" : "navigation__step--disabled")} onClick={onClick} >
      <div className="navigation__step-number">{props.number}</div>
      <div className="navigation__step-label">{props.label}</div>
    </div>
    );
}
